import { AppEffects } from './app.effects'
import { InternationalDataEffects } from './international-data.effects'

export const effects = [AppEffects, InternationalDataEffects]

export * from './app.effects'
export * from './international-data.effects'
